__turbopack_context__.v({
  "actionChip": "Block-module__fs3_EW__actionChip",
  "body": "Block-module__fs3_EW__body",
  "chipsRow": "Block-module__fs3_EW__chipsRow",
  "dragHandle": "Block-module__fs3_EW__dragHandle",
  "empty": "Block-module__fs3_EW__empty",
  "error": "Block-module__fs3_EW__error",
  "footer": "Block-module__fs3_EW__footer",
  "header": "Block-module__fs3_EW__header",
  "headerActions": "Block-module__fs3_EW__headerActions",
  "headerTitle": "Block-module__fs3_EW__headerTitle",
  "iconButton": "Block-module__fs3_EW__iconButton",
  "loading": "Block-module__fs3_EW__loading",
  "narrative": "Block-module__fs3_EW__narrative",
  "root": "Block-module__fs3_EW__root",
  "shimmer": "Block-module__fs3_EW__shimmer",
  "skeleton": "Block-module__fs3_EW__skeleton",
  "subtitle": "Block-module__fs3_EW__subtitle",
  "title": "Block-module__fs3_EW__title",
});
